/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {FC, useEffect, useState} from 'react';
import {StyleProp, Text, View, ViewStyle} from 'react-native';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {MESSAGE_VALIDATION} from '../../../../common/utils/validation';
import {countryData} from '../../../../data/constants/country';
import styles from '../styles';
import {TitleLabel} from './TitleLabel';

interface Props {
  label?: string;
  required?: boolean;
  value?: any;
  onChange: (name: string, value: string, isFired: boolean) => void;
  name?: any;
  error?: any;
  showError?: boolean;
  onBlur?: any;
  onFocus?: any;
  maxLength?: any;
  type?: string;
  isEditable?: boolean;
  onSubmitEditing?: any;
  defaultValue?: string;
  country?: any;
  onChangeCountry?: (country: string) => void;
  style?: StyleProp<ViewStyle>;
  isRapatriement?: boolean;
}

export const InputPhoneNumber: FC<Props> = ({
  label = '',
  required = false,
  value = '',
  onChange,
  name = '',
  error = '',
  showError = false,
  isEditable = true,
  country,
  onChangeCountry,
  style,
  isRapatriement = false,
}) => {
  const defaultCountry = isRapatriement ? 'FR' : 'MG';

  const effectiveCountry = country || defaultCountry;

  const handleChange = (currValue: string, currCountry: any) => {
    const data = currValue.substring(currCountry.dialCode.length);

    if (`0${data}` !== value && data.length <= 15) {
      if (
        typeof onChangeCountry === 'function' &&
        (effectiveCountry !== currCountry.countryCode.toUpperCase() ||
          !effectiveCountry)
      ) {
        onChangeCountry(currCountry.countryCode.toUpperCase());
      }
      onChange(name, data.length > 0 ? `0${data}` : ``, true);
    }
  };

  const [errorToDisplay, setErrorToDisplay] = useState(error);

  const countryExist = (countryCode: string) => {
    // Si aucun code pays n'est fourni, utilisez le pays par défaut
    if (!countryCode) {
      return countryData.find(
        (element: any) => element.code === defaultCountry,
      );
    }

    const countryCodeExist = countryData.find(
      (element: any) => element.code === countryCode,
    );

    // Si le code pays n'existe pas dans les données, retourner le code du pays par défaut
    return (
      countryCodeExist ||
      countryData.find((element: any) => element.code === defaultCountry)
    );
  };

  // Obtenir le dial_code pour le pays actuel
  const getDialCode = (countryCode: string) => {
    const countryInfo = countryExist(countryCode);
    // Utiliser '33' (France) comme fallback si isRapatriement est true, sinon '261' (Madagascar)
    return countryInfo?.dial_code || (isRapatriement ? '33' : '261');
  };

  useEffect(() => {
    setTimeout(() => {
      setErrorToDisplay(error);
    }, 150);
  }, [error]);

  return (
    <View style={[{zIndex: 1, minWidth: 250, marginHorizontal: 5}, style]}>
      <TitleLabel label={label} required={required} />
      <View style={{height: 50, marginBottom: 20}}>
        <PhoneInput
          buttonStyle={{
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            borderRadius: 30,
          }}
          dropdownStyle={{
            position: 'absolute',
            zIndex: 100,
          }}
          containerStyle={{
            marginTop: 5,
            backgroundColor: isEditable
              ? 'transparent'
              : 'rgba(240, 244, 248, 0.87)',
            borderRadius: 30,
            height: '100%',
            width: '100%',
            borderWidth: 1,
            borderColor: 'rgb(224, 224, 224)',
          }}
          inputStyle={{
            borderColor: 'rgb(224, 224, 224)',
            width: '100%',
            backgroundColor: 'transparent',
            height: '100%',
            borderRadius: 30,
            minHeight: '50px',
          }}
          enableSearch
          disableSearchIcon
          disabled={!isEditable}
          searchPlaceholder="Recherche..."
          countryCodeEditable={false}
          // Utilisez le pays effectif (fourni ou par défaut)
          country={
            effectiveCountry
              ? effectiveCountry.toLowerCase()
              : isRapatriement
              ? 'fr'
              : 'mg'
          }
          value={
            value && value[0] && value[0] === '0'
              ? `${getDialCode(effectiveCountry)}${value.substring(1)}`
              : value
              ? value
              : getDialCode(effectiveCountry)
          }
          onChange={(value: string, country: any) =>
            handleChange(value, country)
          }
          isValid={(value: string, country: any) => {
            const phoneRegex = new RegExp(`^${country.dialCode}[0-9]{9}$`);

            if (phoneRegex.test(value)) {
              setErrorToDisplay('');
              return true;
            } else {
              setErrorToDisplay(MESSAGE_VALIDATION.requiredTelephone);
              return false;
            }
          }}
        />
      </View>
      {showError && value && (
        <Text style={[styles.textError, {zIndex: -10}]}>
          {errorToDisplay || error}
        </Text>
      )}
    </View>
  );
};
